<template>
  <h4 class="mx-1">
    <span class="badge badge-light">{{ keyword }}</span>
  </h4>
</template>

<script>
export default {
  name: "KeywordChip",
  props: ['keyword']
}
</script>

<style scoped>

</style>